import { Pipe, PipeTransform } from '@angular/core';
import { OtherNameUtils } from '../../core';

@Pipe({
  name: 'otherNameLabel'
})
export class OtherNameLabelPipe implements PipeTransform {
  transform(otherName: any): string {
    let otherArticleIdentifierLabelTranslationKey = '';
    if (otherName?.pickListData?.identifier) {
      otherArticleIdentifierLabelTranslationKey = OtherNameUtils.abbreviateOtherName(otherName.pickListData.identifier);
    }
    return otherArticleIdentifierLabelTranslationKey;
  }
}
